import { jsxs as _, jsx as n, Fragment as T } from "react/jsx-runtime";
import { c as d } from "./index-65016bfa.mjs";
import x from "react";
import { styled as s, css as c } from "styled-components";
import { Icon as u } from "./icon.js";
import { PopupTip as I } from "./popupTip.js";
import { Tooltip as N } from "./tooltip.js";
const W = s.div`
  &.Label__wrapper {
    ${({
  theme: {
    components: { label: e }
  }
}) => c(e.Wrapper)};
  }
`, f = s.label`
  &.Label__text {
    ${({
  theme: {
    components: { label: e }
  }
}) => c(e.Text)};
  }
`, g = s.span`
  &.Label__trailing-text {
    ${({
  theme: {
    components: { label: e }
  }
}) => c(e.TrailingText)};
  }
`, o = s.span`
  &.Label__info-icon {
    ${({
  theme: {
    components: { label: e }
  }
}) => c(e.InfoIconWrapper)};
  }
`, w = s.span`
  &.Label__required-wrapper {
    ${({
  theme: {
    components: { label: e }
  }
}) => c(e.RequiredWrapper)};
  }
`, $ = s.div`
  &.Label__trailing-element {
    ${({
  theme: {
    components: { label: e }
  }
}) => c(e.TrailingElementWrapper)};
  }
`, q = s(u)`
  &.Label__success-icon {
    ${({
  theme: {
    components: { label: e }
  }
}) => c(e.SuccessIcon)};
  }
`;
function z({ labelProp: e, infoProp: t, trailingText: a, trailingElement: m, as: h = "div", renderAs: L = h, className: p }) {
  const i = (r) => {
    r.stopPropagation();
  };
  return ((e == null ? void 0 : e.label) || (e == null ? void 0 : e.showRequiredIndicator) || (e == null ? void 0 : e.success) || (t == null ? void 0 : t.infoText) || a || x.isValidElement(m)) && /* @__PURE__ */ _(
    W,
    {
      className: d(["Label__wrapper", p]),
      onClick: i,
      as: L,
      children: [
        /* @__PURE__ */ _(
          f,
          {
            htmlFor: e == null ? void 0 : e.htmlFor,
            className: "Label__text",
            id: e == null ? void 0 : e.id,
            children: [
              e == null ? void 0 : e.label,
              (e == null ? void 0 : e.showRequiredIndicator) && /* @__PURE__ */ _(
                w,
                {
                  className: "Label__required-wrapper",
                  "aria-hidden": "true",
                  children: [
                    " ",
                    "*"
                  ]
                }
              ),
              (e == null ? void 0 : e.success) && /* @__PURE__ */ n(
                q,
                {
                  className: "Label__success-icon",
                  name: "checkmark"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ n(g, { className: "Label__trailing-text", children: a }),
        m && /* @__PURE__ */ n($, { className: "Label__trailing-element", children: m }),
        (t == null ? void 0 : t.infoText) && (t.infoType === "tooltip" ? /* @__PURE__ */ n(
          N,
          {
            placement: "auto",
            title: t.infoText,
            className: "Label__tooltip-component",
            children: /* @__PURE__ */ n(
              o,
              {
                tabIndex: 0,
                className: d(["Label__info-icon", "Label__info-icon--tooltip"]),
                onClick: i,
                children: /* @__PURE__ */ n(
                  u,
                  {
                    name: "information",
                    size: "m"
                  }
                )
              }
            )
          }
        ) : t.infoType === "popuptip" ? /* @__PURE__ */ n(
          o,
          {
            className: "Label__info-icon",
            onClick: i,
            onFocus: i,
            children: /* @__PURE__ */ n(
              I,
              {
                placement: "auto",
                popupTipBody: t == null ? void 0 : t.infoText,
                popupTipHeader: t.popupTipHeader,
                showButton: !1,
                children: /* @__PURE__ */ n(
                  o,
                  {
                    tabIndex: 0,
                    className: d(["Label__info-icon--popuptip"]),
                    children: /* @__PURE__ */ n(
                      u,
                      {
                        name: "information",
                        size: "m"
                      }
                    )
                  }
                )
              }
            )
          }
        ) : "")
      ]
    }
  ) || /* @__PURE__ */ n(T, {});
}
export {
  z as L
};
